import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  textSeparator: {
    height: '16px',
  },
  details: {
    height: '24px',
    fontSize: '14px',
    display: 'flex',
  },
});

export default useStyles;
